import React, { useContext, useState } from 'react'
import Field from 'app/React/Components/Footer/Field'
import FooterNavigation from 'app/React/Components/Footer/FooterNavigation'
import PaymentCards from 'app/React/Components/Footer/PaymentCards'
import FooterInfo from 'app/React/Components/Footer/FooterInfo'
import ConfigurationLink from "app/React/Components/Form/ConfigurationLink";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Footer(props) {
  const {
    configurationLinkAvailable,
    paymentCardsImage,
    strings,
  } = useContext(ConfiguratorContext)

  const footerStrings = strings.footer ?? {}
  const [isOpen, setIsOpen] = useState(false)

  const close = () => setIsOpen(false)
  const open = () => setIsOpen(true)

  return (
    <footer className='config-overview-bar' open={isOpen}>
      <div className='config-overview-bar__inner config_page_container'>
        <div className='config-overview-bar__close-fields'>
          <div className='config-overview-bar__close-fields-title'>{footerStrings.overview}</div>
          <div className='config-overview-bar__close-fields-button' onClick={close}>
            {footerStrings.close}
          </div>
        </div>
        <div className='config-overview-bar__fields'>
          {paymentCardsImage?.hasOwnProperty('url') && (
            <Field>
              <PaymentCards/>
            </Field>
          )}
          <Field>
            <FooterInfo/>
          </Field>
        </div>
        <div className='config-overview-bar__open-fields' onClick={open}/>

        {configurationLinkAvailable && (<ConfigurationLink/>)}

        <FooterNavigation/>
      </div>
    </footer>
  )
}
